import { MouseEvent, useMemo, useState } from 'react'
import { v4 as uuid } from 'uuid'
import { GridCellParams, MuiEvent } from '@microservices/wiskey-react-table-component'
import { Box } from '@mui/material'

import { ConfiguredEntityInitialDataWrapper } from '@pages/ConfiguredEntity'
import { OpenFormProps } from '@pages/ConfiguredEntity/types'

import { ModalWrapper } from '@components/ModalWrapper'
import { useHandlers } from '@components/TimeLineGrid/hooks'

import { ENTITY } from '@constants'
import { EntityType, TimeLineDTOType } from '@types'

type ViewOrEditTimeLineItemModalProps = {
  onClose: () => void
  isOpen: boolean
  config: TimeLineDTOType
  data: {
    viewCode?: string
    viewId?: string
    gridCellParams?: GridCellParams
    defaultFilter?: string
  }
  onOpenForm: (
    formProps: OpenFormProps,
    event: MouseEvent<HTMLButtonElement> | MuiEvent<MouseEvent>
  ) => void
  handlers: ReturnType<typeof useHandlers>
}

export const ViewOrEditTimeLineItemModal = (props: ViewOrEditTimeLineItemModalProps) => {
  const { onClose, isOpen, data, config, onOpenForm: handleOpenForm, handlers } = props

  const dialogId = useMemo(() => uuid(), [])

  const [entity, setEntity] = useState<EntityType | null>(null)
  const {
    data: { objectYPKField },
  } = handlers

  const handleSetEntity = (entity: EntityType | null) => setEntity(entity)

  return (
    <ModalWrapper
      disableEnforceFocus
      hideActions
      hideDivider
      isDialogOverModal
      height={'90vh'}
      isShow={isOpen}
      title={data?.gridCellParams?.row?.yElement.name}
      width={'95%'}
      onClose={onClose}
    >
      <Box sx={{ height: `calc(100% - ${32}px)`, display: 'flex', flexDirection: 'column' }}>
        <ConfiguredEntityInitialDataWrapper
          isViewDialogWindow
          defaultFilter={data?.defaultFilter}
          dialogId={dialogId}
          entity={entity}
          entityCode={data.viewCode || ''}
          entityId={data.viewId ?? ''}
          path={''}
          title={'Info'}
          type={ENTITY.VIEW}
          prefillCreateObjectRecordInForm={{
            objectCode: config.objectY.objectCode,
            objectId: objectYPKField?.name
              ? data?.gridCellParams?.row?.yElement?.[objectYPKField.name]
              : '',
          }}
          onOpenForm={handleOpenForm}
          onSetEntity={handleSetEntity}
        />
      </Box>
    </ModalWrapper>
  )
}
